// Billing V2's canonical Billing Entity value set (the `…/CodeSystem/encounter-billing-entity`
// tag codes). Lives in a `*.contract.ts` file so the oRPC billing contracts can import it
// across the web package boundary (the bundle guard only lets `*.contract.ts` /
// `contracts.ts` cross from middleware).
//
// care-coordination/dto/billing-entity.constants.ts keeps its own copy for the legacy
// list-encounters filter — a deliberate mirror, NOT an import: the legacy module and
// billing-v2 stay decoupled until the legacy billing path is sunset.
export const BILLING_ENTITY_VALUES = ['FL', 'NJ', 'NY'] as const

export type BillingEntityValue = (typeof BILLING_ENTITY_VALUES)[number]

export const BILLING_ENTITY_LABELS: Record<BillingEntityValue, string> = {
  FL: 'Florida, beHuman Medical, PA',
  NJ: 'New Jersey beHuman Medical, NJ',
  NY: 'New York beHuman Medical Group, NY',
}
